import { defineAsyncComponent, reactive, ref, markRaw } from 'vue'
import { getDepartmentList, getActivity } from '@/api/HealthRecord/index.js'

const tabs = ref([
  { label: '基本信息', component: 'baseInfo', ref: 'baseInfo' },
  {
    label: '病史信息',
    component: 'medicalHistoryInfo',
    ref: 'medicalHistoryInfo'
  },
  { label: '生活方式', component: 'lifeStyle', ref: 'lifeStyle' }
])

const component = reactive({
  baseInfo: markRaw(defineAsyncComponent(() => import('../baseInfo.vue'))),
  medicalHistoryInfo: markRaw(defineAsyncComponent(() => import('../medicalHistoryInfo.vue'))),
  lifeStyle: markRaw(defineAsyncComponent(() => import('../lifeStyle.vue')))
})
// 问题类型: 1整数，2小数，3日期，4单行文本，5 多行文本 6 单选框，7 地区，8，12 下拉,9 多选框
const formItemType = [
  {
    fType: 1,
    type: 'number',
    default: null
  },
  {
    fType: 2,
    type: 'number',
    default: null
  },
  {
    fType: 3,
    type: 'date',
    default: undefined
  },
  {
    fType: 4,
    type: 'string',
    default: ''
  },
  {
    fType: 5,
    type: 'string',
    default: ''
  },
  {
    fType: 6,
    type: 'string',
    default: ''
  },
  {
    fType: 7,
    type: 'array',
    default: []
  },
  //下拉是string类型
  {
    fType: 8,
    type: 'string',
    default: null
  },
  {
    fType: 9,
    type: 'array',
    default: []
  },
  {
    fType: 10,
    type: 'array',
    default: []
  },
  {
    fType: 11,
    type: 'array',
    default: []
  },
  //下拉是number类型
  {
    fType: 12,
    type: 'number',
    default: null
  },
  //
  {
    fType: 13,
    type: 'boolean',
    default: null
  }
]
// 问题类型: 1整数，2小数，3日期，4单行文本，5 多行文本 6 单选框，7 地区，8 下拉
const infoList = [
  {
    label: '姓名',
    require: false,
    type: 4,
    u: '',
    children: [
      {
        label: '姓名',
        key: 'patientName',
        value: '',
        disabled: true,
        isShow: true
      }
    ]
  },
  {
    label: '性别',
    require: false,
    type: 8,
    u: '',
    children: [
      {
        label: '性别',
        key: 'gender',
        value: null,
        disabled: true,
        isShow: true
      }
    ]
  },
  {
    label: '年龄',
    require: false,
    type: 1,
    u: '',
    children: [
      {
        label: '年龄',
        key: 'age',
        value: null,
        disabled: true,
        isShow: true
      }
    ]
  },

  {
    label: '地区',
    require: false,
    type: 7,
    children: [
      {
        label: '地区',
        key: 'region',
        value: [],
        disabled: false,
        isShow: true
      }
    ]
  },
  {
    label: '体重',
    require: false,
    type: 1,
    u: 'kg',
    children: [
      {
        label: '体重',
        key: 'weight',
        value: null,
        disabled: false,
        isShow: true
      }
    ]
  },
  {
    label: '身高',
    require: false,
    type: 2,
    u: 'cm',
    children: [
      {
        label: '身高',
        key: 'height',
        value: null,
        disabled: false,
        isShow: true
      }
    ]
  },
  {
    label: '婚育情况',
    require: false,
    type: 8,
    children: [
      {
        label: '婚姻情况',
        key: 'marriage',
        value: '',
        disabled: false,
        isShow: true
      },
      {
        label: '孕育情况',
        key: 'pregnant',
        value: '',
        disabled: false,
        isShow: true
      }
    ]
  }
]

//病史信息  // 问题类型: 1整数，2小数，3日期，4单行文本，5 多行文本 6 单选框，7 地区，8 下拉,9 多选框,10 下拉多级 99自定义Slot
const medicalHistoryList = [
  {
    key: 'patientName',
    title: '姓名',
    disabled: false,
    slots: false,
    type: 4,
    required: true,
    placeholder: '请输入姓名',
    allowClear: false,
    isShow: false,
    maxlength: 30
  },
  {
    key: 'patientAge',
    title: '年龄',
    disabled: false,
    slots: false,
    type: 1,
    required: true,
    placeholder: '请输入年龄',
    allowClear: false,
    isShow: false,
    max: 120,
    min: 1,
    u: '岁'
  },
  {
    key: 'patientGender',
    title: '性别',
    disabled: false,
    slots: false,
    type: 12,
    required: true,
    placeholder: '请选择性别',
    allowClear: false,
    isShow: false,
    options: [
      {
        value: 0,
        label: '女'
      },
      {
        value: 1,
        label: '男'
      }
    ]
  },
  {
    key: 'offlineDiagnosis',
    title: '诊断名称',
    disabled: false,
    slots: true,
    type: 10,
    required: true,
    placeholder: '请输入诊断名称',
    allowClear: true,
    isShow: true,
    maxlength: 50,
    bottomBorder: true
  },
  {
    key: 'patientProfile',
    title: '关联就诊人',
    disabled: false,
    slots: true,
    type: 10,
    required: true,
    isShow: true,
    bottomBorder: true
  },
  {
    key: 'retreatment',
    title: '预约复诊',
    disabled: false,
    slots: true,
    type: 99,
    required: false,
    isShow: true,
    bottomBorder: true
  },
  {
    key: 'switchBlock',
    slots: true,
    isShow: true,
    type: 99,
    notForm: false
  },
  {
    key: 'description',
    title: '病情描述',
    disabled: false,
    slots: false,
    type: 5,
    required: false,
    placeholder: '请输入病情描述',
    allowClear: true,
    isShow: true,
    maxlength: 2000,
    marginTop: true,
    isExpend: false
  },
  {
    key: 'fileList',
    auxiliaryKey: 'ocrImgUrlList',
    title: '上传处方',
    disabled: false,
    slots: false,
    type: 11,
    required: false,
    isShow: true,
    imgMaxLength: 1,
    tips: '上传处方图片',
    guide: '如何上传',
    isExpend: false
  },
  {
    key: 'fileList',
    auxiliaryKey: 'imgUrlList',
    title: '上传病历、检查检验报告等',
    disabled: false,
    slots: false,
    type: 11,
    required: false,
    isShow: true,
    imgMaxLength: 20,
    tips: '上传病历、检查检验报告等图片',
    isExpend: false
  },
  {
    key: 'healthFileList',
    auxiliaryKey: 'checklistFileList',
    title: '检查检验单',
    disabled: false,
    slots: false,
    type: 11,
    required: false,
    placeholder: '请上传检查检验单',
    imgMaxLength: 20,
    isShow: false
  },
  {
    key: 'inquiryTime',
    title: '就诊时间',
    disabled: false,
    slots: false,
    type: 3,
    required: false,
    requiredOcr: true,
    placeholder: '请选择就诊时间',
    allowClear: true,
    isShow: true,
    disabledDate: '>days',
    isExpend: false
  },
  {
    key: 'isOpenDrug',
    title: '是否用药',
    disabled: false,
    slots: false,
    type: 13,
    required: false,
    placeholder: '',
    allowClear: false,
    isShow: true,
    maxlength: 50,
    checkedChildren: '是',
    unCheckedChildren: '否',
    isExpend: false
  },
  // {
  //   key: 'prescriptionInfo.activityId',
  //   auxiliaryKey: 'medicationNames',
  //   keyOne: 'prescriptionInfo',
  //   keyTwo: 'activityId',
  //   title: '活动名称',
  //   disabled: false,
  //   slots: false,
  //   type: 12,
  //   required: false,
  //   requiredDrug: false,
  //   placeholder: '请选择活动名称',
  //   allowClear: false,
  //   isShow: true,
  //   form: 'drug',
  //   options: [
  //     {
  //       label: '不参与活动',
  //       value: 0
  //     }
  //   ]
  // },
  {
    key: 'drugInput',
    title: '处方药品',
    disabled: false,
    slots: true,
    type: 9,
    required: true,
    requiredDrug: true,
    placeholder: '请输入处方药品',
    allowClear: false,
    isShow: true,
    form: 'drug',
    isExpend: false
  },

  // {
  //   key: 'prescriptionInfo.beginTime', //startDate
  //   keyOne: 'prescriptionInfo',
  //   keyTwo: 'beginTime',
  //   title: '开始时间',
  //   disabled: false,
  //   slots: false,
  //   type: 3,
  //   required: true,
  //   requiredDrug: true,
  //   requiredOcr: true,
  //   placeholder: '请选择开始时间',
  //   isShow: true,
  //   allowClear: true,
  //   form: 'drug',
  //   disabledDate: '>days',
  //   isExpend: false
  // },
  // {
  //   key: 'prescriptionInfo.medicineCycle', //period
  //   keyOne: 'prescriptionInfo',
  //   keyTwo: 'medicineCycle',
  //   title: '用药周期',
  //   disabled: false,
  //   slots: false,
  //   type: 1, //8
  //   required: true,
  //   requiredDrug: true,
  //   placeholder: '请选择用药周期',
  //   isShow: true,
  //   allowClear: false,
  //   options: getOptions(),
  //   max: 90,
  //   min: 1,
  //   u: '天',
  //   form: 'drug',
  //   isExpend: false
  // },
  {
    key: 'hospitalName',
    title: '就诊医院',
    disabled: false,
    slots: false,
    type: 4,
    required: false,
    requiredOcr: true,
    placeholder: '请输入就诊医院',
    isShow: true,
    form: 'drug',
    allowClear: true,
    maxlength: 50,
    isExpend: false
  },
  {
    key: 'offlineDoctorName',
    title: '就诊医生',
    disabled: false,
    slots: false,
    type: 4,
    required: false,
    requiredOcr: true,
    placeholder: '请输入就诊医生',
    isShow: true,
    form: 'drug',
    allowClear: true,
    maxlength: 10,
    isExpend: false
  },
  {
    key: 'patientName',
    title: '就诊人',
    disabled: false,
    slots: false,
    type: 4,
    required: false,
    requiredOcr: true,
    placeholder: '请输入就诊人',
    isShow: true,
    form: 'drug',
    allowClear: true,
    maxlength: 20,
    isExpend: false,
    validator: 'patientNameValidator'
  },
  // {
  //   key: 'prescriptionInfo.endTime', //endDate
  //   keyOne: 'prescriptionInfo',
  //   keyTwo: 'endTime',
  //   title: '结束时间',
  //   disabled: true,
  //   slots: false,
  //   type: 3,
  //   required: false,
  //   requiredDrug: false,
  //   placeholder: '结束时间',
  //   allowClear: false,
  //   isShow: false,
  //   showForm: false,
  //   form: 'drug',
  //   isExpend: false
  // },
  {
    key: 'patientPermission',
    title: '补充的信息是否患者可见',
    disabled: false,
    slots: false,
    type: 13,
    required: false,
    placeholder: '',
    allowClear: false,
    isShow: true,
    checkedChildren: '是',
    unCheckedChildren: '否',
    isExpend: false
  },
  {
    key: 'doctorPermission',
    title: '补充的信息是否医生可见',
    disabled: false,
    slots: false,
    type: 13,
    required: false,
    placeholder: '',
    allowClear: false,
    isShow: true,
    checkedChildren: '是',
    unCheckedChildren: '否',
    isExpend: false
  }
]

const effectShow = [
  'description',
  'fileList',
  'inquiryTime',
  'isOpenDrug',
  'drugInput',
  'prescriptionInfo.beginTime',
  'prescriptionInfo.medicineCycle',
  'prescriptionInfo.endTime',
  'patientPermission',
  'doctorPermission',
  'hospitalName',
  'offlineDoctorName',
  'patientName'
]
const getDepartList = () => {
  //获取就诊科室
  return getDepartmentList().then(res => {
    if (res && res.length > 0) {
      medicalHistoryList.find(item => item.key == 'offlineDepartment').options = res
    }
    return res
  })
}

//获取线上活动
const getActivityList = () => {
  getActivity().then(res => {
    if (res && res.length > 0) {
      const options = res.map(item => {
        return {
          label: item.activityTemplateName,
          value: item.id
        }
      })
      const optionsData = medicalHistoryList.find(item => item.key == 'prescriptionInfo.activityId')
      optionsData.options = [
        {
          label: '不参与活动',
          value: 0
        }
      ]
      optionsData.options.push(...options)
    }
  })
}

function getOptions() {
  const optionsList = []
  for (let i = 0; i < 90; i++) {
    const params = {
      label: i + 1,
      value: i + 1 + ''
    }
    optionsList.push(params)
  }
  return optionsList
}

export {
  tabs,
  component,
  infoList,
  formItemType,
  medicalHistoryList,
  getDepartList,
  getActivityList,
  effectShow
}
